// extracted by mini-css-extract-plugin
export default {"logo-ingenico":"LogoMarkup-module__logo-ingenico--2bJbu","logo-type":"LogoMarkup-module__logo-type--38EAa","logo":"LogoMarkup-module__logo--2M5R8"};